export default {
    api:{
        index:'/agent/index/index',//首页
        login:'/agent/user/login',//登录
        deliveryOrder:'/agent/inventory/deliveryOrder',//发货管理
        queryOrderNo:'/agent/queryOrderNo',
        graphCode:'/agent/index/graphCodeVerify',//获取图片验证码
        getSmsCode:'/agent/user/getSmsCode',//获取短信验证码
        register:'/agent/user/register',//
        updateUserLevel:'/agent/user/updateUserLevel',//更新用户等级
        setJypass:'/agent/user/setJyPwd',//设置交易密码
        updateJypass:'/agent/user/updateJyPwd',//修改交易密码
        stock:'/agent/inventory/index',//我的御粮库存页面接口
        pickApply:'/agent/inventory/purchaseList',//进货申请页面接口
        preconfirmPickapply:'/agent/inventory/purchase',//预提交进货申请
        getPickupConfirmInfo:'/agent/inventory/purchasedetail',//获取提货确认页信息
        confirmPickapply:'/agent/inventory/purchaseconfirm',//提交进货申请
        pickupGoods:'/agent/inventory/deliverylist',//提货商品
        confirmPickup:'/agent/inventory/delivery',//预确认提货接口
        addressAdd:'/agent/address/save',//添加地址
        addressList:'/agent/address/list',//地址列表
        getAddDetail:'/agent/address/detail',//获取地址信息
        validatePassword:'/agent/inventory/checkJyPassword',//校验交易密码
        realConfirmPickup:'/agent/inventory/deliveryconfirm',//确认提货接口
        stockList:'/agent/inventory/list',//进/提货订单
        pickupDetail:'/agent/inventory/deliverydetail',//提货详情
        purchaseDetail:'/agent/inventory/purchasedetail',//进货详情
        stockDetail:'/agent/inventory/record',//库存明细
        accountOverview:'/agent/account/index',//账户总揽
        accountList:'/agent/account/accountList',//账户明细
        replenishmentInfo:'/agent/account/accountInfo',//补款申请页面所需数据
        picUpload:'/agent/account/upload',//补款凭证上传
        confirmBk:'/agent/account/confirmPayment',//确认补款
        replenishmentDetail:'/agent/account/getPaymentInfo',//补款详情
        referralReward:'/agent/recommend/index',//推荐奖励
        useReferralInfo:'/agent/recommend/getExchangeInfo',//“使用推荐奖励”页面信息接口
        submitDhOrder:'/agent/recommend/exchange',//“使用推荐奖励页”提交订单按钮接口
        prevUseReferral:'/agent/recommend/exchangeCofirm',//预确认兑换
        dhRecord:'/agent/recommend/exchangeList',//兑换记录
        dhRecordDetail:'/agent/recommend/exchangeDetail',//兑换记录详情
        recommendList:'/agent/recommend/inviteList',//我推荐的人
        chairmanAllowance:'/agent/allowance/index',//战略合伙人津贴
        confirmWithdraw:'/agent/allowance/confirm',//确认申请提现
        confirmHz:'/agent/allowance/confirmTransfer',//确认划转
        salesIncentive:'/agent/salesReward/index',//销售奖励
        getFareInfo:'/agent/inventory/countpostage',//获取运费信息
        pervRenzheng:'/agent/user/certification',//认证请求前调
        checkUserData:'/agent/user/updateState',//重新获取用户数据（用来实时查询最新用户状态）
        updateUserStatus:'/agent/user/updateUserStatus',//更改用户状态 type 1认证，2 签约
        qianyue:'/agent/user/signing',//签约接口
        orderTracking:'/agent/inventory/express',//订单跟踪接口
        getSignUrl:'/agent/user/showSignUrl',//获取签约合同地址
        validationPwd:'/agent/user/validationPwd',//验证旧密码
        getduihuanRecord:'/agent/recommend/accountList',//获取兑换记录
        customerInfo:'/agent/customerInfo/save',//保存加盟信息
        subpageIndex:'/agent/storeAccount/index',//御粮荟储值页面
        subpageDetail:'/agent/storeAccount/accountList',//储值资金明细
    }
}